/* eslint-disable @typescript-eslint/naming-convention */
import { get } from '@core/api/baseApi';
import { GetOrganizationTemplateResponse } from '@core/types/ApiResponses';

const getOrganizationTemplate = (templateId: string): Promise<GetOrganizationTemplateResponse> =>
  get(`/organizations/templates/${templateId}`);

export { getOrganizationTemplate };
